export const esAuth = {
  'auth.brand': 'FinanceGo',
  'auth.email': 'Email',
  'auth.genericError': 'No pudimos completar el acceso. Intenta otra vez.',
  'auth.googleUnavailable': 'Google no está disponible en este momento.',
  'auth.loading': 'Preparando tu cuenta',
  'auth.login': 'Entrar',
  'auth.loginSubtitle': 'Entra para ver tu plan financiero.',
  'auth.name': 'Nombre',
  'auth.password': 'Contraseña',
  'auth.passwordHint': 'Usa al menos 12 caracteres para crear una cuenta.',
  'auth.register': 'Crear cuenta',
  'auth.registerSubtitle': 'Organiza tu dinero con una cuenta de FinanceGo.',
  'auth.retry': 'Reintentar conexión',
  'auth.showLogin': 'Ya tengo cuenta',
  'auth.showRegister': 'Crear una cuenta',
  'auth.submitLogin': 'Entrar',
  'auth.submitRegister': 'Crear cuenta',
  'auth.titleLogin': 'Bienvenido de vuelta',
  'auth.titleRegister': 'Empieza con claridad',
} as const;

export const enAuth: Record<keyof typeof esAuth, string> = {
  'auth.brand': 'FinanceGo',
  'auth.email': 'Email',
  'auth.genericError': 'We could not complete sign-in. Try again.',
  'auth.googleUnavailable': 'Google is not available right now.',
  'auth.loading': 'Preparing your account',
  'auth.login': 'Sign in',
  'auth.loginSubtitle': 'Sign in to view your financial plan.',
  'auth.name': 'Name',
  'auth.password': 'Password',
  'auth.passwordHint': 'Use at least 12 characters to create an account.',
  'auth.register': 'Create account',
  'auth.registerSubtitle': 'Organize your money with a FinanceGo account.',
  'auth.retry': 'Retry connection',
  'auth.showLogin': 'I already have an account',
  'auth.showRegister': 'Create an account',
  'auth.submitLogin': 'Sign in',
  'auth.submitRegister': 'Create account',
  'auth.titleLogin': 'Welcome back',
  'auth.titleRegister': 'Start with clarity',
};
